import BaseQuestionModel from '../BaseQuestionModel'

import { IQuestionModelConstructor, QuestionType } from '../types'
import { IImageQuestionModelState, IImageResponseValidation, ImageQuestionModelTypes } from './types'

const ImageQuestionModel: IQuestionModelConstructor<ImageQuestionModelTypes> = (questionSchema, action) => {
  const { model } = BaseQuestionModel<ImageQuestionModelTypes, IImageQuestionModelState>({
    questionType: QuestionType.IMAGE,
    questionSchema: questionSchema,
    action,
    submitResponse,
    initState,
    validateResponse
  })
  return model
}

function submitResponse({ response }: IImageQuestionModelState) {
  return [response.response]
}

function initState(state: IImageQuestionModelState): IImageQuestionModelState {
  state.response = { response: { id: state.questionSchema.id } }
  return state
}

function validateResponse({ response, questionSchema }: IImageQuestionModelState): IImageResponseValidation {
  return {
    valid: questionSchema.image ? response.viewed : true
  }
}

export default ImageQuestionModel
